import React from 'react';

import { Button } from 'components/ui';
import IconArrowsSort from 'components/ui/icons/IconArrowsSort';
import IconChevronDown from 'components/ui/icons/IconChevronDown';
import Modal from 'components/ui/Modal';
import { cx } from 'helpers/StylingHelpers';
import { useTranslation } from 'hooks/common/useTranslation';
import { useIsOpen } from 'hooks/useIsOpen';

import OrderByOptions from './OrderByOptions';

import type { IListingOrderBy, IListingOrderByOption, IUrl } from 'types';

import styles from './OrderByMobile.module.scss';

interface Props {
  className?: string,
  //
  label?: string,
  orderBy: IListingOrderBy,
  //
  getHref: (option: IListingOrderByOption) => IUrl
}

const OrderByMobile = (props: Props) => {

  const {
    className,
    //
    label,
    orderBy,
    //
    getHref,
  } = props;

  // Hooks

  const { t } = useTranslation();
  const { isOpen, open, close, } = useIsOpen();

  // Handlers

  const onOptionChange = () => {
    close();
  };

  // Render

  return (
    <div
      className={cx(
        styles.root,
        className
      )}
    >

      {/* Select Button */}
      <Button
        className={styles.selectBtn}
        type="button"
        endIcon={label ? IconChevronDown : IconArrowsSort}
        endIconProps={{
          className: label ? styles.chevronIcon : styles.sortIcon,
          size: label ? 16 : 20,
        }}
        onClick={open}
      >
        {label || t('LISTING_TOOLBAR.ORDER_BY.LABEL_SHORT')}
      </Button>

      {/* Modal */}
      <Modal
        isOpen={isOpen}
        classNames={{
          overlay: styles.modal,
          content: styles.modalContent,
        }}
        title={t('LISTING_TOOLBAR.ORDER_BY.LABEL_SHORT')}
        breakpoint="md"
        responsiveProps={{
          position: 'bottom'
        }}
        onClose={close}
      >
        <div className={styles.modalBody}>
          <OrderByOptions
            orderBy={orderBy}
            onChange={onOptionChange}
            getHref={getHref}
          />
        </div>
      </Modal>

    </div>
  );
};

// Export

export default OrderByMobile;
